import { render, staticRenderFns } from "./NotasLocais.vue?vue&type=template&id=dfc1f7cc&scoped=true"
import script from "./NotasLocais.vue?vue&type=script&lang=js"
export * from "./NotasLocais.vue?vue&type=script&lang=js"
import style0 from "./NotasLocais.vue?vue&type=style&index=0&id=dfc1f7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc1f7cc",
  null
  
)

export default component.exports